<template>
  <div>
    <rest-menu
      :restId="restId"
      :restColor="restInfo.restColor"
      :menuTabs="menuTypeTabs"
      :pageBanner="restInfo.pageBanner"
      :restInfoBanner="restInfo.restInfoBanner"
      :deliveryTime="deliveryTime"
      :menuHero="restInfo.menuHero"
      :restInfoModal="restInfo.restInfoModal"
      :showSpecialItem="restInfo.showSpecialItem"
      :cartCount="cartCount"
      :blockedMessage="restInfo.blockedMessage"
      :closedMessage="restInfo.closedMessage"
      :default-address="defaultAddress"
      :default-city="defaultCity"
      :default-state="defaultState"
      :showVerifyAddress="showVerifyAddress"
      :mapCenterLat="mapCenterLat"
      :mapCenterLng="mapCenterLng"
      :restZone="restZone"
      :initDefaultTab="initDefaultTab"
    />
  </div>
</template>

<script>
import RestMenu from './RestMenu.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'MenuPage',
  components: {
    RestMenu,
  },
  created() {
    this.setInitState()
  },
  props: {
    restId: [String, Number],
    showVerifyAddress: String,
    defaultAddress: String,
    defaultCity: String,
    defaultState: String,
    mapCenterLat: [String, Number],
    mapCenterLng: [String, Number],
    restZone: [String, Number],
  },
  computed: {
    ...mapState({
      menuTypeTabs: (state) => state.restMenu.tabs,
      currentTab: (state) => state.restMenu.currentTab,
      initDefaultTab: (state) => state.restMenu.initDefaultTab,
      restInfo: (state) => state.restMenu.restInfo,
      deliveryTime: (state) => state.restMenu.deliveryTime,
      cartCount: (state) => state.restMenu.customerCart.cartCount,
    }),
  },
  methods: {
    ...mapActions({
      setInitState: 'restMenu/setInitState',
    }),
  },
}
</script>
